import React from "react";
import { Routes, Route } from "react-router-dom";
import SearchPCN from "../components/SearchPCN";
import PCNDetails from "../components/PCNDetails";
function Routing() {
    return (
        <Routes>
            <Route
                path={`/`}
                element={<SearchPCN />}
            />
            <Route
                path={`/:id`}
                element={<PCNDetails />}
            />
        </Routes>
    );
}

export default Routing;
